import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuildings = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 3H15V7.25H21V18.5H23V20H1V18.5H3V3ZM4.5 18.5H13.5V4.5H4.5V18.5ZM15 18.5H19.5V8.75H15V18.5ZM7 8H11V9.5H7V8ZM7 12H11V13.5H7V12Z",
		fill: "currentColor"
	})]
});
export default SvgBuildings;
